import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';
import { AIResponse, FahrzeugNeuwertResponse } from '@/features/AI/types';

export class AIHttpService extends HttpService {
  getDataByDocument(formData: FormData): HttpClientResponse<AIResponse> {
    return this.httpClient.post('ai/data/by-document', {
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  getFahrzeugNeuwert(
    data: Record<string, any>,
  ): HttpClientResponse<FahrzeugNeuwertResponse> {
    return this.httpClient.post('ai/data/neuwert', {
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}
